import { FC, useEffect, useState } from 'react';
import { SubscriptionState } from '../../../hooks/App/useSubscription';
import { Panel, PanelText, PanelTitle } from '../../common/Panel';
import { SUBSCRIPTION_NAME } from '../../../constants';

export const Remarks: FC<{
  subscription: SubscriptionState
}> = ({subscription}) => {

  const [body, setBody] = useState('');
  const [title, setTitle] = useState('');

  useEffect(() => {
    if (!subscription) return;
    const remarks = subscription.shop.mypageRemarks;

    const title = remarks.match(/<title>(.*?)<\/title>/)?.[1] || `${SUBSCRIPTION_NAME}からのお知らせ`;
    setTitle(title);

    const body = remarks.replace(/<title>.*?<\/title>/, '');
    setBody(body);
  }, [subscription]);

  return body ? (
    <Panel>
      <PanelTitle>{title}</PanelTitle>
      <PanelText useRender>{ body }</PanelText>
    </Panel>
  ) : <></>;
}